module.exports = __webpack_public_path__ + "static/media/budget-icon-selected.8db80614.svg";